export const zIndex = {
  piece: 5,
  dimmed: 9,
  rewardBox: 10,
  rewardBoxSkin: 11,
  rewardBoxSlot: 12,
  rewardBoxText: 13,
} as const;
